import React, { useEffect, useState } from "react";
import SliderCards from "./SliderCards";
import { UseGetProductsByCondition } from "../../../staticQueries/useGetProductsByCondition";
import { UseGetProductsByEnvironment } from "../../../staticQueries/useGetProductsByEnvironment";
import { UseGetProductsByLayeringSystem } from "../../../staticQueries/useGetProductByLayeringSystem";
import { GatsbyImage } from "gatsby-plugin-image";

function TypeButton({ isActive, children, ...props }) {
  return (
    <button
      className={`bg-transparent rounded-full ${
        isActive
          ? "lg:bg-[#1f1f1f] text-black lg:text-white hover:bg-opacity-80"
          : "text-black hover:text-[#1f1f1f]"
      } ${
        isActive && "border-2 border-solid border-black"
      } text-[15px] md:text-base sm:font-bold box-border
      lg:border-none px-6 md:px-[30px] py-2 md:py-[10px]`}
      {...props}
    >
      {children}
    </button>
  );
}

const borderTop =
  "rounded-tl-[10px] rounded-bl-[10px] lg:rounded-bl-none lg:rounded-tl-[15px] lg:rounded-tr-[15px]";

const borderBottom =
  "rounded-br-[10px]  rounded-tr-[10px] lg:rounded-tr-none lg:rounded-bl-[15px] lg:rounded-br-[15px]";

function ProductsSection() {
  const productsByCondition = UseGetProductsByCondition();
  const productsByEnvironment = UseGetProductsByEnvironment();
  const productsByLayeringSystem = UseGetProductsByLayeringSystem();

  const [handle, setHandle] = useState("condition");
  const [categories, setCategories] = useState(productsByCondition || {});
  const [products, setProducts] = useState(
    categories[Object.keys(categories)[0]] || {}
  );

  useEffect(() => {
    setProducts(categories[Object.keys(categories)[0]]);
  }, [categories]);

  return (
    <React.Fragment>
      <div className="w-full px-5 xl:px-[90px] box-border">
        <div className="flex flex-wrap flex-col lg:flex-row lg:flex-nowrap justify-between items-center md:mb-8">
          <h2 className="md:min-w-[370px] w-max mt-5 text-center lg:text-left text-3xl md:text-[40px] font-bold mb-[10px] lg:mb-5">
            Shop products by
          </h2>
          <div className="w-full flex items-center justify-center lg:justify-end sm:gap-5 flex-wrap lg:flex-nowrap">
            <TypeButton
              isActive={handle === "condition"}
              onClick={() => {
                setHandle("condition");
                setCategories(productsByCondition);
              }}
            >
              Condition
            </TypeButton>
            <TypeButton
              isActive={handle === "environment"}
              onClick={() => {
                setHandle("environment");
                setCategories(productsByEnvironment);
              }}
            >
              Environment
            </TypeButton>
            <TypeButton
              isActive={handle === "layeringSystem"}
              onClick={() => {
                setHandle("layeringSystem");
                setCategories(productsByLayeringSystem);
              }}
            >
              Layering System
            </TypeButton>
          </div>{" "}
        </div>
      </div>
      <div className="flex flex-wrap py-[30px] pl-5 xl:pl-[90px] mb-[90px] box-border justify-between">
        <div
          className="relative w-full lg:w-1/4 mr-5 md:mr-[30px] lg:mr-0 flex flex-row lg:flex-col gap-[3px]
          md:gap-[10px] text-white"
        >
          {Object.entries(categories).map(([, value], index) => (
            <div
              className="w-1/4 lg:w-full h-24 lg:h-1/4 relative z-[1] cursor-pointer"
              key={value.id}
              onClick={() => setProducts(value)}
            >
              <div
                className={`relative w-full h-full items-center group border-inherit overflow-hidden z-[-1] 
                ${index === 0 && borderTop} ${
                  index === Object.entries(categories).length - 1 &&
                  borderBottom
                }`}
                role="group"
              >
                {value.image?.gatsbyImageData && (
                  <div className="absolute w-full h-full object-cover">
                    <GatsbyImage
                      image={value.image.gatsbyImageData}
                      alt={value.image.altText || value.title}
                      loading="lazy"
                      objectFit="cover"
                      className="relative w-full h-full object-cover"
                    />
                  </div>
                )}
                <h3
                  className="flex items-center justify-center box-border w-full h-full z-[1] backdrop-brightness-[0.7]
                group-hover:backdrop-brightness-90 font-bold text-white text-sm md:text-[25px] py-[10px] px-[14px]"
                >
                  {value.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
        <div className="flex flex-col w-full lg:w-[74%] mt-[30px] lg:mt-0">
          <SliderCards
            products={products?.products.slice(0, 3)}
            handle={products?.handle}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

export default React.memo(ProductsSection);
